const RIGHT = /right/;
const LEFT = /left/;
const TOP = /top/;
const BOTTOM = /bottom/;

/**
 * Calculate the document-based top-left point to position a rendered
 * ContextualLayer.
 */
function calculateContextPoint(config) {
  const {
    contextRect,
    contextMeetingPoint,
    layerRect,
    layerMeetingPoint
  } = config; // eslint-disable-next-line @typescript-eslint/no-use-before-define

  const {
    x,
    y
  } = calculateContextXY(contextRect, contextMeetingPoint); // eslint-disable-next-line @typescript-eslint/no-use-before-define

  const {
    x: adjustX,
    y: adjustY
  } = calculateLayerAdjustment(layerRect, layerMeetingPoint);
  return {
    x: Math.round(x + adjustX + config.offsetX),
    y: Math.round(y + adjustY + config.offsetY)
  };
}

function calculateContextXY(contextRect, contextMeetingPoint) {
  let {
    left: x,
    top: y
  } = contextRect;
  const {
    width,
    height
  } = contextRect;

  if (RIGHT.test(contextMeetingPoint)) {
    x += width;
  } else if (!LEFT.test(contextMeetingPoint)) {
    x += 0.5 * width;
  }

  if (BOTTOM.test(contextMeetingPoint)) {
    y += height;
  } else if (!TOP.test(contextMeetingPoint)) {
    y += 0.5 * height;
  }

  return {
    x,
    y
  };
}

function calculateLayerAdjustment(layerRect, layerMeetingPoint) {
  const {
    width,
    height
  } = layerRect;
  let x = 0;
  let y = 0;

  if (!RIGHT.test(layerMeetingPoint) && !LEFT.test(layerMeetingPoint)) {
    x = -0.5 * width;
  }

  if (!BOTTOM.test(layerMeetingPoint) && !TOP.test(layerMeetingPoint)) {
    y = -0.5 * height;
  }

  return {
    x,
    y
  };
}

export default calculateContextPoint;